/* istanbul ignore file */

export enum RecipientType {
    List = 1,
    Field = 2,
}
